import { createSlice } from '@reduxjs/toolkit';

const messagesSlice = createSlice({
    name: 'messages',
    initialState: { chat_prompt: [] },

    reducers: {
        addMessage: (state, action) => {
            const { role, content, promptItems, context, icon, componentType = 'text' } = action.payload;

            state.chat_prompt.push({
                role,
                componentType,
                content: [{ type: 'text', text: content[0].text }], // ✅ Ensure proper structure
                context,
                promptItems,
                icon,
            });
        },
        clearMessages: (state) => {
            state.chat_prompt = [];
        },
    },
});

export const { addMessage, clearMessages } = messagesSlice.actions;
export default messagesSlice.reducer;

export const selectChatContext = (state) => state.messages.chat_prompt;
